import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ActivatedRoute, Router } from '@angular/router';
import { appstraxAuth, User } from '@appstrax/services/auth';
import { mapAuthErrorMessage } from '../../../utils/auth-error.util';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.page.html',
  styleUrls: ['./verify-email.page.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class VerifyEmailPage {
  private readonly route = inject(ActivatedRoute);

  readonly authStep = this.route.snapshot.data['authStep'] as number | undefined;
  readonly setupSteps = [1, 2, 3];

  errorMessage: string = '';
  isLoading: boolean = false;
  code: string = '';

  constructor(private router: Router) {}

  public async verifyEmail() {
    if (!this.isFormValid()) {
      this.errorMessage = 'Please enter the code you received';
      return;
    }

    this.isLoading = true;
    this.errorMessage = '';

    try {
      const user: User = await appstraxAuth.verifyEmailAddress(this.code);
      if (user) this.router.navigate(['/create-organization']);
    } catch (error: any) {
      this.errorMessage = mapAuthErrorMessage(error);
    } finally {
      this.isLoading = false;
    }
  }

  public isFormValid() {
    return this.code != '';
  }
}
